// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ktZv3aTpkBR4GY {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.LxOsSWlKdqjdnr {
  display: flex;
  justify-content: center;
}
.LLyjunH4vAxp5m {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.hmRuT4jkRNG8JB {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.jblNL0wa3SR29R {
  font-style: italic;
}
.d3mqFRdEFXLG7R {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.NDu9Sl4FXvIwUx {
  display: flex;
  align-items: center;
  justify-content: center;
}
.uVR7w8JDjj3biv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.uVR7w8JDjj3biv .grkgpaFGJ6ms8m {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.vwUD6AClqdQGsn {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.vwUD6AClqdQGsn button {
  margin-left: var(--ds-space-100, 8px);
}
.zT8v3SME3ZH7Xn {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .d3mqFRdEFXLG7R {
    padding: var(--ds-space-200, 16px);
  }
}
.JXAwPWunsjdYBA {
  min-width: 250px;
}
.JXAwPWunsjdYBA label {
  font-weight: var(--ds-font-weight-bold, 700);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
}
.JXAwPWunsjdYBA input[type='text'] {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-150, 12px);
}
.JXAwPWunsjdYBA input[type='text']:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.JXAwPWunsjdYBA input[type='text']:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.JXAwPWunsjdYBA input[type='text']:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.JXAwPWunsjdYBA input[type='text'][readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.JXAwPWunsjdYBA input[type='text'].zfEEoEa8PuEwub {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.JXAwPWunsjdYBA input[type='text'].zfEEoEa8PuEwub:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.JXAwPWunsjdYBA input[type='text'].zfEEoEa8PuEwub:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.JXAwPWunsjdYBA input[type='text'].TlEKL32aIKcc5S {
  width: 100%;
}
.JXAwPWunsjdYBA input[type='text']::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.iyXSreNi_E9egL {
  align-items: center;
}
.iyXSreNi_E9egL .YF6ApAbg3V5Czx {
  margin-right: var(--ds-space-200, 16px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `ktZv3aTpkBR4GY`,
	"flexAndCenter": `LxOsSWlKdqjdnr`,
	"body": `LLyjunH4vAxp5m`,
	"navigationAndContent": `hmRuT4jkRNG8JB`,
	"learnMoreSubtle": `jblNL0wa3SR29R`,
	"content": `d3mqFRdEFXLG7R`,
	"spinnerContainer": `NDu9Sl4FXvIwUx`,
	"header": `uVR7w8JDjj3biv`,
	"title": `grkgpaFGJ6ms8m`,
	"footer": `vwUD6AClqdQGsn`,
	"formFooter": `zT8v3SME3ZH7Xn`,
	"pluginInput": `JXAwPWunsjdYBA`,
	"input-error": `zfEEoEa8PuEwub`,
	"full": `TlEKL32aIKcc5S`,
	"deleteFooter": `iyXSreNi_E9egL`,
	"deleteWarning": `YF6ApAbg3V5Czx`
};
export default ___CSS_LOADER_EXPORT___;
